import utils from "@/components/mixins/utils";

export default {
  computed: {
    catalogLink() {
      if (!this.user.targetHome) return "https://deascuola.it/novita-2020-2021-hp/";
      return `${this.user.targetHome}#dea-target-menu-section`;
    },
    agentsUrl() {
      if (this.user.authenticated) return utils.addRedirect(this.$root.config.agents_url, document.location.href);
      return this.$root.config.support_url;
    },
  },
};
